import { useState } from "react";

import DatePicker from "@usas/ui-web/components/datepickers/DatePicker";
import PrimaryButton from "@usas/ui-web/components/buttons/PrimaryButton";
import SecondaryButton from "@usas/ui-web/components/buttons/SecondaryButton";

import { isValidBirthDate, isValidDate } from "@usas/ui-web/utils/validation";
import { BLANK_DATE_STRING } from '@usas/ui-web/utils/Constants';

const ConfirmAgeForm = ({
  confirmAgeData,
  onSubmitFormCallback,
  onSecondaryButtonClicked
}) => {
  const [formState, setFormState] = useState({
    birthDate: confirmAgeData?.birthDate || ''
  });
  const [errorState, setErrorState] = useState({
    birthDate: ''
  });

  const onValueChanged = (fieldName, fieldKey, value) => {
    setFormState(prev => ({
      ...prev,
      [fieldKey]: value
    }));

    // Clear error when user starts typing
    if (errorState[fieldKey]) {
      setErrorState(prev => ({
        ...prev,
        [fieldKey]: ''
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!formState.birthDate?.trim() || formState.birthDate?.trim() === BLANK_DATE_STRING) {
      errors.birthDate = 'Birth Date is required'
    } else if (!isValidDate(formState.birthDate)) {
      errors.birthDate = 'Birth Date must be a valid date';
    } else if (!isValidBirthDate(formState.birthDate)) {
      errors.birthDate = 'Birth Date cannot be in the future'
    }

    setErrorState(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm() && onSubmitFormCallback) {
      onSubmitFormCallback(formState);
    }
  };

  const handleSecondaryClick = (e) => {
    e.preventDefault();

    if (onSecondaryButtonClicked) {
      onSecondaryButtonClicked(formState);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-xs-12">
          <DatePicker
            label="Birth Date"
            name="birthDate"
            value={formState.birthDate}
            error={!!errorState.birthDate}
            message={errorState.birthDate}
            autoFocus={true}
            onChange={(value) => onValueChanged('Birth Date', 'birthDate', value)}
          />
        </div>
        <div className="col-xs-12 usas-extra-top-margin">
          <PrimaryButton type="submit">
            Continue
          </PrimaryButton>
        </div>
        <div className="col-xs-12 usas-extra-top-margin">
          <SecondaryButton onClick={handleSecondaryClick}>
            Back
          </SecondaryButton>
        </div>
      </div>
    </form>
  );
};

export default ConfirmAgeForm;